<template>
  <partner-layout>
    <v-container fluid>
      <v-layout wrap>
        <!-- <v-flex xs12 sm3 class="px-1">
          <multiselect
            v-model="status"
            :options="statusOptions"
            label="text"
            selectLabel
            selectedLabel
            :allow-empty="false"
            :searchable="false"
            deselect-label
            track-by="text"
          ></multiselect>
        </v-flex> -->
        <v-flex xs12 sm3 class="form-control px-1">
          <input type="text" v-model="search" :placeholder="$t('Search')" />
        </v-flex>
        <v-flex xs12 sm6 class="text-xs-left text-sm-right"> </v-flex>
      </v-layout>

      <div>
        <v-data-table :headers="headers" :items="computedRedeemCode" class="elevation-1">
          <template v-slot:items="props">
            <tr @click="onShow(props.item)">
              <td>
                <v-avatar size="25">
                  <img
                    class="responsive-img circle"
                    style="min-width: 100%"
                    alt
                    @error="onError"
                    :src="
                      'https://graph.facebook.com/' +
                        props.item.facebook +
                        '/picture?width=100&height=100&SameSite=None'
                    "
                  />
                </v-avatar>
              </td>
              <td>
                {{ props.item.customer_name }}
              </td>
              <td>{{ props.item.email }}</td>
              <td>{{ props.item.phoneno }}</td>
              <!-- <td>
              <v-chip v-if="props.item.botstatus" color="green" small dark>{{
                $t('active')
              }}</v-chip>
              <v-chip v-else color="red" small dark>{{ $t('inactive') }}</v-chip>
            </td> -->

              <td>
                <template v-if="props.item.expireat">{{
                  props.item.expireat | DateFormat('DD MMM YYYY HH:mm')
                }}</template
                ><template v-else>-</template>
              </td>
              <td>
                {{ props.item.pagecount }}
              </td>
              <!-- <td>{{ props.item.facebook ? props.item.facebook : '-' }}</td> -->

              <td class="text-xs-center">
                {{ props.item.numofredeem ? props.item.numofredeem : '0' }}
              </td>

              <td>
                <v-btn fab outline small><v-icon>search</v-icon></v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <v-dialog v-model="showDialog" persistent max-width="600">
        <v-card v-if="selectedCustomer">
          <div class="text-xs-right">
            <v-btn flat fab small @click="showDialog = false"><v-icon>close</v-icon></v-btn>
          </div>
          <v-card-text>
            <div class="text-xs-center">
              <v-avatar size="130">
                <img
                  class="responsive-img circle"
                  style="min-width: 100%"
                  alt
                  @error="onError"
                  :src="
                    'https://graph.facebook.com/' +
                      selectedCustomer.facebook +
                      '/picture?width=100&height=100&SameSite=None'
                  "
                />
              </v-avatar>
              <div class="mt-2">{{ selectedCustomer.customer_name }}</div>
              <v-layout class="my-4">
                <v-flex class="text-xs-center" style="border-right: 1px solid #eee">
                  <div class="caption">
                    Number of Redeem
                  </div>
                  <div class=" primary--text">
                    {{ selectedCustomer.numofredeem }}
                  </div>
                </v-flex>
                <v-flex class="text-xs-center" style="border-right: 1px solid #eee">
                  <div class="caption">
                    Continued Redeem
                  </div>
                  <div class=" primary--text">
                    {{ selectedCustomer.numofredeem }}
                  </div>
                </v-flex>
                <v-flex class="text-xs-center">
                  <div class="caption">
                    Page Amount
                  </div>
                  <div class=" primary--text">
                    {{ selectedCustomer.pagecount }}
                  </div>
                </v-flex>
              </v-layout>

              <!-- <div class="caption">Redeem Status</div>
              <v-chip color="primary" dark v-if="selectedCustomer.redeemstatus">Redeem</v-chip> -->
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12 sm6 class="my-3"
                ><div class="caption">Email</div>
                <div class="primary--text">
                  <a :href="`mailto:${selectedCustomer.email}`">{{ selectedCustomer.email }}</a>
                </div></v-flex
              >
              <v-flex xs12 sm6 class="my-3"
                ><div class="caption">Facebook</div>
                <div class="primary--text">
                  <a :href="`https://www.facebook.com/${selectedCustomer.facebook}`" target="_blank"
                    >{{ selectedCustomer.pagename }}
                    <v-icon small color="primary">launch</v-icon></a
                  >
                </div></v-flex
              >
              <v-flex xs12 sm6 class="my-3"
                ><div class="caption">Phone No</div>
                <div class="primary--text">
                  <a :href="`tel:${selectedCustomer.phoneno}`">
                    {{ selectedCustomer.phoneno }}
                  </a>
                </div></v-flex
              >
            </v-layout>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text>
            <div class=" primary--text">
              Pages
            </div>
            <v-data-table
              :headers="customer_headers"
              :items="selectedCustomer.lists"
              class="elevation-1"
            >
              <template v-slot:items="props">
                <tr>
                  <td>
                    <v-avatar size="25">
                      <img
                        class="responsive-img circle"
                        style="min-width: 100%"
                        alt
                        @error="onError"
                        :src="
                          'https://graph.facebook.com/' +
                            props.item.facebook +
                            '/picture?width=100&height=100&SameSite=None'
                        "
                      />
                    </v-avatar>
                  </td>
                  <td>
                    {{ props.item.pagename }}
                  </td>
                  <td>
                    <v-chip v-if="props.item.botstatus" color="green" small dark>{{
                      $t('active')
                    }}</v-chip>
                    <v-chip v-else color="red" small dark>{{ $t('inactive') }}</v-chip>
                  </td>
                  <td>
                    {{ props.item.numofredeem }}
                  </td>
                  <td>
                    {{ props.item.business_type }}
                  </td>

                  <td>
                    <template v-if="props.item.activateat">
                      {{ props.item.activateat | DateFormat('DD/MM/YYYY HH:mm') }}
                    </template>
                    <template v-else>-</template>
                  </td>
                  <td>
                    <template v-if="props.item.expireat">
                      {{ props.item.expireat | DateFormat('DD/MM/YYYY HH:mm') }}
                    </template>
                    <template v-else>-</template>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </partner-layout>
</template>

<script>
import Multiselect from 'vue-multiselect'
import dayjs from 'dayjs'
import { mapGetters } from 'vuex'
import api from '@/api'
export default {
  data() {
    return {
      search: '',
      status: null,
      showDialog: false,
      selectedCustomer: null,
      statusOptions: [
        {
          text: 'All',
          value: null
        },
        {
          text: this.$t('active'),
          value: true
        },
        {
          text: this.$t('inactive'),
          value: false
        }
      ],
      customer_headers: [
        {
          text: '',
          sortable: false
        },
        {
          text: 'Page Name',
          value: 'pagename'
        },
        { text: 'Bot Status', value: 'botstatus' },
        {
          text: 'Number of Redeem',
          value: 'numofredeem'
        },
        {
          text: 'Business Type',
          value: 'business_type'
        },
        {
          text: 'Activate at',
          value: 'activateat'
        },
        {
          text: 'Expire at',
          value: 'expireat'
        }
      ],
      headers: [
        {
          text: '',
          sortable: false
        },
        {
          text: 'Customer Name',
          value: 'customer_name'
        },
        { text: 'Email', value: 'email' },
        { text: 'Phone No', value: 'phoneno' },
        {
          text: 'Expired At',
          value: 'expireat'
        },
        {
          text: 'Page Count',
          value: 'pagecount'
        },
        // {
        //   text: 'Facebook',
        //   value: 'facebook'
        // },
        {
          text: 'Number of Redeem',
          value: 'numofredeem',
          align: 'center'
        },
        {
          text: '',
          sortable: false
        }
      ],
      customers: []
    }
  },
  async mounted() {
    let response = await this.getPartnerCustomers()
    if (response.responsecode == 200 && response.data) {
      var customers = response.data
      let group = customers.reduce((r, a) => {
        r[a.customer_name] = [...(r[a.customer_name] || []), a]
        return r
      }, {})

      var customers_grouped = []
      for (const key in group) {
        if (group.hasOwnProperty(key)) {
          const element = group[key]
          var sorted_element = element.sort((a, b) => dayjs(a.expireat).diff(dayjs(b.expireat)))
          const e = {
            activateat: null,
            customer_name: null,
            email: null,
            expireat: null,
            facebook: null,
            numofredeem: 0,
            pagename: null,
            phoneno: null,
            redeemstatus: false,
            pagecount: sorted_element.length,
            lists: sorted_element
          }
          if (sorted_element.length > 0) {
            e.activateat = sorted_element[0].activateat
            e.customer_name = sorted_element[0].customer_name
            e.email = sorted_element[0].email
            e.expireat = sorted_element[0].expireat
            e.facebook = sorted_element[0].facebook
            var totalredeem = 0
            sorted_element.map(element => {
              // console.log(
              //   totalredeem,
              //   parseInt(element.numofredeem),
              //   totalredeem + parseInt(element.numofredeem)
              // )
              return totalredeem + parseInt(element.numofredeem)
            })
            e.numofredeem = totalredeem
            e.pagename = sorted_element[0].pagename
            e.phoneno = sorted_element[0].phoneno
            e.redeemstatus = sorted_element[0].redeemstatus
          }
          customers_grouped.push(e)
        }
      }
      this.customers = customers_grouped
      // console.log(this.customers)
    }
  },
  components: {
    Multiselect
  },
  computed: {
    computedRedeemCode() {
      var customers = [...this.customers]

      if (this.status && this.status.value != null) {
        customers = this.customers.filter(el => {
          return el.botstatus == this.status.value
        })
      }
      return customers.filter(el => {
        return (
          (el.customer_media_name &&
            el.customer_media_name.toLowerCase().includes(this.search.toLowerCase())) ||
          (el.email && el.email.toLowerCase().includes(this.search.toLowerCase())) ||
          (el.phoneno && el.phoneno.toLowerCase().includes(this.search.toLowerCase())) ||
          el.pagename.toLowerCase().includes(this.search.toLowerCase())
        )
      })
    }
  },
  methods: {
    onError: function(event) {
      $(event.target).attr('src', '/static/img/assets/livechat/profile.png')
    },
    onShow(customer) {
      this.showDialog = true
      this.selectedCustomer = customer
    },
    getPartnerCustomers() {
      var data = {
        partner_code: this.$store.state.partner_code
      }
      return new Promise((resolve, reject) => {
        api.getPartnerCustomers(data, (error, response) => {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/partner/Customer.vue